import { createSlice } from "@reduxjs/toolkit";
import { Category } from "../../@types/Category";
import { Status } from "../../@types/status";
import { findCategory } from "./actions/findCategory";
import { findStatus } from "./actions/findStatus";

interface UtilsState {
  status: Status[];
  category: Category[];
}

const initialState = {
  status: [],
  category: [],
} as UtilsState;

const utilsSlice = createSlice({
  name: "utils",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(findStatus.fulfilled, (state, { payload }) => {
      state.status = [...payload];
    });
    builder.addCase(findCategory.fulfilled, (state, { payload }) => {
      state.category = [...payload];
    });
  },
});

export default utilsSlice.reducer;
